export default {
  title: {
    id: 'models_comparison_result_title',
    defaultMessage: '{firstModel} Vs {secondModel}',
  },
}
